module.exports = __webpack_public_path__ + "static/media/gold_birthday.1ee98c9c.png";